import React from 'react';
import godrejLogo from "../../assets/img/godrej-logo-dark.svg";

const InactiveEmployee = ({ message }) => {
  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f8f9fa',
    fontFamily: 'GB-BodyCopy',
    padding: '20px'
  };

  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '10px',
    padding: '40px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    maxWidth: '500px',
    width: '100%'
  };

  const titleStyle = {
    color: '#810055',
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '20px',
    fontFamily: 'GB-Headline'
  };

  const messageStyle = {
    color: '#707070',
    fontSize: '16px',
    lineHeight: '1.5',
    marginBottom: '30px'
  };

  const buttonStyle = {
    backgroundColor: '#810055',
    color: 'white',
    border: 'none',
    padding: '12px 30px',
    borderRadius: '5px',
    fontSize: '16px',
    cursor: 'pointer',
    fontFamily: 'GB-BodyCopy'
  };

  const logoStyle = {
    marginBottom: '30px',
    maxWidth: '200px'
  };

  const handleContactHR = () => {
    window.open('mailto:hr@godrej.com?subject=Account Deactivation Inquiry', '_blank');
  };

  const handleGoBack = () => {
    window.location.href = '/';
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <img src={godrejLogo} alt="Godrej Logo" style={logoStyle} />
        
        <h2 style={titleStyle}>Account Deactivated</h2>
        
        <p style={messageStyle}>
          {message || 'Your account has been deactivated. Please contact HR for assistance.'}
        </p>
        
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button 
            style={buttonStyle} 
            onClick={handleContactHR}
            onMouseOver={(e) => e.target.style.backgroundColor = '#6a0045'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#810055'}
          >
            Contact HR
          </button>
          
          <button 
            style={{...buttonStyle, backgroundColor: '#6c757d'}} 
            onClick={handleGoBack}
            onMouseOver={(e) => e.target.style.backgroundColor = '#5a6268'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#6c757d'}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default InactiveEmployee;
